(function polyfill() {
  const relList = document.createElement("link").relList;
  if (relList && relList.supports && relList.supports("modulepreload")) return;

  for (const link of document.querySelectorAll('link[rel="modulepreload"]')) {
    processPreload(link);
  }

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== "childList") continue;
      for (const node of mutation.addedNodes) {
        if (node.tagName === "LINK" && node.rel === "modulepreload") processPreload(node);
      }
    }
  }).observe(document, { childList: true, subtree: true });

  function getFetchOpts(link) {
    const fetchOpts = {};
    if (link.integrity) fetchOpts.integrity = link.integrity;
    if (link.referrerPolicy) fetchOpts.referrerPolicy = link.referrerPolicy;
    if (link.crossOrigin === "use-credentials") fetchOpts.credentials = "include";
    else if (link.crossOrigin === "anonymous") fetchOpts.credentials = "omit";
    else fetchOpts.credentials = "same-origin";
    return fetchOpts;
  }

  function processPreload(link) {
    if (link.ep) return;
    link.ep = true;
    const fetchOpts = getFetchOpts(link);
    fetch(link.href, fetchOpts);
  }
})();

document.addEventListener("DOMContentLoaded", () => {
  function initTabs() {
    const tabSpans = document.querySelectorAll(".in-guide__navItem");
    const tabItems = document.querySelectorAll(".in-guide__tabItem");

    tabSpans.forEach((span) => {
      span.addEventListener("click", (event) => {
        event.preventDefault();
        const target = span.getAttribute("data-target");
        if (!target) return;

        tabSpans.forEach((s) => s.classList.remove("is-active"));
        span.classList.add("is-active");

        tabItems.forEach((item) => item.classList.remove("is-active"));
        const targetTab = document.querySelector(target);
        if (targetTab) targetTab.classList.add("is-active");
      });
    });
  }

  function toggleFixBtnActive() {
    const fv = document.getElementById("js-fv");
    const fixBtn = document.getElementById("js-fixBtn");
    if (!fv || !fixBtn) return;

    const fvHeight = fv.offsetHeight;
    const scrollY = window.scrollY || window.pageYOffset;
    if (scrollY >= fvHeight) fixBtn.classList.add("is-active");
    else fixBtn.classList.remove("is-active");
  }

  function toggleMovieFilter() {
    const filterTrigger = document.querySelector(".js-filterTrigger");
    const mainMovie = document.querySelector(".l-main__movie");
    if (!filterTrigger || !mainMovie) return;

    const rect = filterTrigger.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const triggerTop = rect.top;

    if (triggerTop <= windowHeight / 2) mainMovie.classList.add("add-filter");
    else mainMovie.classList.remove("add-filter");
  }

  function switchViewport() {
    const viewport = document.querySelector('meta[name="viewport"]');
    if (!viewport) return;

    const value = window.outerWidth > 375 ? "width=device-width,initial-scale=1" : "width=375";
    if (viewport.getAttribute("content") !== value) viewport.setAttribute("content", value);
  }

  let rAFId = null;
  function onScrollOrResize() {
    if (rAFId !== null) return;
    rAFId = window.requestAnimationFrame(() => {
      toggleMovieFilter();
      toggleFixBtnActive();
      switchViewport();
      rAFId = null;
    });
  }

  function initExternalLinks() {
    document.querySelectorAll('a[href^="http"]').forEach((link) => {
      if (!link.href.includes(window.location.hostname)) {
        link.setAttribute("target", "_blank");
        link.setAttribute("rel", "noopener noreferrer");
        link.classList.add("blank");
      }
    });
  }

  initTabs();
  initExternalLinks();
  window.addEventListener("scroll", onScrollOrResize, { passive: true });
  window.addEventListener("resize", onScrollOrResize);
  toggleMovieFilter();
  toggleFixBtnActive();
  switchViewport();
});
